import React from "react";
import { motion } from "framer-motion";
import { TEAM } from "../lib/team";

export const TeamGrid = ({ dark = false }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-px" style={{ background: dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)" }} data-testid="team-grid">
    {TEAM.map((m, i) => (
      <motion.div
        key={m.name}
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: i * 0.08 }}
        className="p-6 sm:p-8"
        style={{ background: dark ? "#000" : "#F2EFE9" }}
        data-testid={`team-member-${m.name.toLowerCase()}`}
      >
        <div className="text-[11px] mb-6" style={{ color: "#FF2800", letterSpacing: "0.2em" }}>
          {String(i + 1).padStart(2, "0")}
        </div>
        <div className="text-2xl sm:text-3xl mb-2" style={{ color: dark ? "#FFF" : "#111", fontWeight: 300, letterSpacing: "-0.02em" }}>
          {m.name}
        </div>
        <div className="text-[12px] uppercase tracking-[0.2em]" style={{ color: "#8a8a8a" }}>
          {m.role}
        </div>
      </motion.div>
    ))}
  </div>
);
